import styleInject from '../../../node_modules/.pnpm/style-inject@0.3.0/node_modules/style-inject/dist/style-inject.es.js';

var css_248z = ".Badge-module_badge__RsuMz{border-radius:4px;box-sizing:border-box;font-size:12px;font-weight:500;line-height:16px;padding:2px 4px;text-transform:capitalize;width:min-content}.Badge-module_primary__S0WCS{background:var(--attention-background);color:var(--text-accent-primary-label)}.Badge-module_grayscale__RpdZ8{background:var(--information-background);color:var(--text-secondary-label)}";
var style = {"badge":"Badge-module_badge__RsuMz","primary":"Badge-module_primary__S0WCS","grayscale":"Badge-module_grayscale__RpdZ8"};
styleInject(css_248z);

export { style as default };
//# sourceMappingURL=Badge.module.css.js.map
